import Fleet from '@/models/fleet'

export default {
  fleets: [],
  fleet: new Fleet().getObject(),
  currentFleetId: '',
  availabilityInfo: [],
  nextAvailablePage: 0,
  currentPage: 0,
  pageSize: 9,
  fleetTypes: ['PREPAID', 'POSTPAID'],
  fleetsLoaded: false
}
